import { css, DefaultTheme } from "styled-components";
import { BOTTOM_NAVIGATOR, NEW_LOOK_BOTTOM_NAVIGATOR } from "common/constants";

/** Horizontal padding of new-look pages inside the canvas (desktop). */
export const NEW_LOOK_PAGE_GUTTER = 32;
export const NEW_LOOK_TABLET_PAGE_GUTTER = 24;
export const NEW_LOOK_PAGE_GUTTER_VAR = `var(--new-look-page-gutter, ${NEW_LOOK_PAGE_GUTTER}px)`;
/** Vertical gap between sections of a new-look page. */
export const NEW_LOOK_SECTION_GAP = 16;
/** Icon stroke used across the new look (lucide). */
export const NEW_LOOK_ICON_STROKE = 1.75;

/**
 * Phone spacing (new look, bottom-navigator layout). One gutter for every
 * page, drawer body and drawer header; panels pad their content by the same.
 */
export const NEW_LOOK_PHONE_GUTTER = 16;
/** Vertical gap between sections on a phone page. */
export const NEW_LOOK_PHONE_SECTION_GAP = 24;
/** Vertical padding of a list row on phone. */
export const NEW_LOOK_PHONE_ROW_PAD = 12;
export const NEW_LOOK_PHONE_CARD_GAP = 16;
export const NEW_LOOK_PHONE_HERO_MIN_FONT_SIZE = 20;
/** Visual height of phone controls (chips, filter pills, segmented tabs). */
export const NEW_LOOK_PHONE_CONTROL = 36;
/** Minimum touch target on phone; controls pad their hit area up to it. */
export const NEW_LOOK_PHONE_HIT = 40;

export const NEW_LOOK_PHONE_MAX_WIDTH = "599.98px";
export const NEW_LOOK_CARDS_VIEW_MAX_WIDTH = "1099.98px";

export const phoneMaxWidth = ({ theme }: { theme: DefaultTheme }) =>
  theme.hasNewLookBreakpoints ? NEW_LOOK_PHONE_MAX_WIDTH : BOTTOM_NAVIGATOR;

export const NEW_LOOK_NARROW_PHONE_QUERY = "(max-width: 359.98px)";

export const phoneTwoLineTitle = css`
  @media (max-width: ${NEW_LOOK_PHONE_MAX_WIDTH}) {
    display: -webkit-box;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;

export const phoneMinWidth = ({ theme }: { theme: DefaultTheme }) =>
  theme.hasNewLookBreakpoints ? NEW_LOOK_BOTTOM_NAVIGATOR : BOTTOM_NAVIGATOR;
